import { render, staticRenderFns } from "./UiSmartIcon.vue?vue&type=template&id=824bfe7c"
import script from "./UiSmartIcon.vue?vue&type=script&lang=js"
export * from "./UiSmartIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports